<mat-sidenav-container [hidden]="!isLogged">
  <mat-sidenav #sidenav="matSidenav">
    <app-sidenav
      [user]="user"
      [isAdmin]="isAdmin"
      [version]="version"
    ></app-sidenav>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (isImpersonating && user) {
      <div class="impersonation-banner">
        <mat-icon>visibility</mat-icon>
        <span>Estás actuando como <strong>{{ user.name }}</strong></span>
        <button type="button" (click)="stopImpersonation()">
          Volver a administrador
        </button>
      </div>
    }
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
